<template>
    <div class="reg-temp-content-area p-3 main-content-height">
        <div class="superadmin-dashboard-area edit-area">
            <loading v-if="loading" />
            <div class="row" v-else>
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="registered-product-item w-half">
                                <router-link :to="{name: 'DistributorCustomers'}" class="mb-3 inline-block"
                                    ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                                >
                                <h3 class="mb-4">Edit User</h3>
                                <ul>
                                    <li class="mb-3">
                                        <span class="semibold mb-2">User type</span>
                                        <strong class="text-capitalize display-role-not-editable">{{ form.role }}</strong>
                                    </li>

                                    <li>
                                        <span class="semibold mb-2">First Name:</span>
                                        <span><input type="text" v-model="form.fname" name="fname" class="form-control" /></span>
                                    </li>

                                    <li>
                                        <span class="semibold mb-2">Last name:</span>
                                        <span><input type="text" v-model="form.lname" name="lname" class="form-control" /></span>
                                    </li>

                                    <li>
                                        <span class="semibold mb-2">Company:</span>
                                        <span><input type="text" v-model="form.company" name="company" class="form-control" /></span>
                                    </li>

                                    <li>
                                        <span class="semibold mb-2">Address:</span>
                                        <span class="notice">( Please select the address from suggestion )</span>
                                        <!-- <span><input type="text" v-model="form.address" name="address" class="form-control" /></span> -->
                                        <span>
                                            <gmap-autocomplete
                                                id="distributor_edit_address"
                                                autocomplete="nope"
                                                class="form-control"
                                                large
                                                name="address"
                                                placeholder="your address..."
                                                :select-first-on-enter="true"
                                                :componentRestrictions="{country: ['ZA']}"
                                                @place_changed="setPlace"
                                                @keyup="resetPlace"
                                            >
                                            </gmap-autocomplete>
                                        </span>
                                        <div class="address-info-wrap" v-if="form.address && form.addressDetail && form.addressDetail.province">
                                            <p class="address-info"><span>Province:</span> {{ form.addressDetail.province }}</p>
                                            <p class="address-info"><span>City:</span> {{ form.addressDetail.city }}</p>
                                            <p class="address-info"><span>Suburb:</span> {{ form.addressDetail.suburb }}</p>
                                            <p class="address-info"><span>Postcode:</span> {{ form.addressDetail.postcode }}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="semibold mb-2">Complex/Building + Unit:</span>
                                        <span
                                            ><input
                                                type="text"
                                                v-model="form.complex_building_unit"
                                                name="complex_building_unit"
                                                class="form-control"
                                        /></span>
                                    </li>

                                    <li>
                                        <span class="semibold mb-2">Mobile:</span>
                                        <span><input type="text" v-model="form.mobile" name="mobile" class="form-control" /></span>
                                    </li>

                                    <template>
                                        <li class="form-group" v-if="form.role == 'reseller'">
                                            <div class="mb-3 mt-3">
                                                <div>
                                                    <span class="semibold mb-2">Has website?</span>
                                                    <div class="form-check form-check-inline">
                                                        <input
                                                            v-model.number="form.has_website"
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="haveWebsite"
                                                            id="website_yes"
                                                            value="1"
                                                        />
                                                        <label class="form-check-label" for="website_yes">Yes</label>
                                                    </div>
                                                    <div class="form-check form-check-inline">
                                                        <input
                                                            v-model.number="form.has_website"
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="haveWebsite"
                                                            id="website_no"
                                                            value="0"
                                                        />
                                                        <label class="form-check-label" for="website_no">No</label>
                                                    </div>
                                                </div>
                                                <div v-if="form.has_website == 1" class="website-holder">
                                                    <span class="website-prefix dark">https://</span>
                                                    <input type="text" v-model="form.website" placeholder="eg: example.com" class="form-control" />
                                                </div>
                                            </div>
                                            <!-- Website:
                                            <input type="text" v-model="form.website" placeholder="Website" class="form-control" /> -->
                                        </li>

                                        <li class="form-group" v-if="form.role == 'reseller'">
                                            <span class="semibold mb-2">Reseller Type:</span>
                                            <select v-model="form.reseller_type" class="baseline-input">
                                                <option value="">--Select reseller type--</option>
                                                <option
                                                    :value="resellerType.value"
                                                    v-bind:key="resellerType.value"
                                                    v-for="resellerType in resellerTypes"
                                                >
                                                    {{ resellerType.label }}
                                                </option>
                                            </select>
                                        </li>

                                        <li v-if="form.role == 'reseller'">
                                            <span class="semibold mb-2">Select Region:</span>
                                            <select v-model="form.region" class="baseline-input">
                                                <option value="">--Select region--</option>
                                                <option :value="region" v-bind:key="region" v-for="region in regions">{{ region }}</option>
                                            </select>
                                        </li>
                                    </template>

                                    <li>
                                        <button class="btn btn-primary mt-3 px-5" @click.prevent="updateResellerCustomer()">+ UPDATE</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Helpers from '@/helpers/index';

export default {
    name: 'distributorCustomerEdit',
    data() {
        return {
            loading: true,
            form: {
                fname: '',
                lname: '',
                company: '',
                address: '',
                website: '',
                has_website: 0,
                complex_building_unit: '',
                addressDetail: {
                    province: '',
                    city: '',
                    suburb: '',
                    postcode: '',
                    lat: '',
                    lng: ''
                },
                mobile: '',
                role: 'customer',
                region: '',
                reseller_type: ''
            }
        };
    },

    computed: {
        regions() {
            return Env.regions;
        },
        resellerTypes() {
            return Env.resellerTypes;
        }
    },

    mounted() {
        this.fetchDetail();
    },

    methods: {
        async fetchDetail() {
            const self = this;
            const url = `${Env.baseUrl}/distributor/customers/show/${this.$route.params.customer_id}`;
            AuthApis.getApi(url)
                .then((res) => {
                    for (let key in this.form) {
                        if (
                            key == 'addressDetail' &&
                            !_.isEmpty(res.data.payload.user_metas) &&
                            res.data.payload.user_metas.lat &&
                            res.data.payload.user_metas.lng
                        ) {
                            this.form[key] = {
                                province:
                                    res.data.payload.user_metas && res.data.payload.user_metas.province ? res.data.payload.user_metas.province : '',
                                city: res.data.payload.user_metas && res.data.payload.user_metas.city ? res.data.payload.user_metas.city : '',
                                suburb: res.data.payload.user_metas && res.data.payload.user_metas.suburb ? res.data.payload.user_metas.suburb : '',
                                postcode:
                                    res.data.payload.user_metas && res.data.payload.user_metas.postcode ? res.data.payload.user_metas.postcode : '',
                                lat: res.data.payload.user_metas && res.data.payload.user_metas.lat ? res.data.payload.user_metas.lat : '',
                                lng: res.data.payload.user_metas && res.data.payload.user_metas.lng ? res.data.payload.user_metas.lng : ''
                            };
                        } else {
                            this.form[key] = res.data.payload[key];
                            this.form.website =
                                res.data.payload.user_metas && res.data.payload.user_metas.website ? res.data.payload.user_metas.website : '';
                            this.form.has_website =
                                res.data.payload.user_metas && res.data.payload.user_metas.has_website ? res.data.payload.user_metas.has_website : 0;
                            this.form.complex_building_unit =
                                res.data.payload.user_metas && res.data.payload.user_metas.complex_building_unit
                                    ? res.data.payload.user_metas.complex_building_unit
                                    : '';
                            this.form.reseller_type =
                                res.data.payload.user_metas && res.data.payload.user_metas.reseller_type
                                    ? res.data.payload.user_metas.reseller_type
                                    : '';
                        }
                    }
                    this.loading = false;
                    this.$nextTick(() => {
                        if (document.getElementById('distributor_edit_address')) {
                            document.getElementById('distributor_edit_address').value = self.form.address;
                        }
                    });
                })
                .catch((err) => {
                    this.loading = false;
                });
        },

        async updateResellerCustomer() {
            this.spinner(true);
            const url = `${Env.baseUrl}/distributor/customers/update/${this.$route.params.customer_id}`;
            AuthApis.postApi(url, this.form)
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: 'Successfully Updated.'
                    });
                })
                .catch((err) => {
                    this.spinner(false);
                    this.$toasted.global.error({
                        message: err.response ? (err.response.data ? err.response.data.errors[0] : 'Fail.') : 'Please try again later.'
                    });
                });
        },

        /**
         * Autocomplete set
         */
        setPlace: async function (addressData) {
            if (_.isEmpty(addressData)) {
                return;
            }
            this.form.address = addressData.formatted_address;
            let province = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1');
            let city = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_2');
            let suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_1');
            if (!suburb) {
                suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_2');
            }
            let postcode = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'postal_code');
            let {lat, lng} = Helpers.getLatLngFromGoogleAutoComplete(addressData);
            this.form.addressDetail = {
                province,
                city,
                suburb,
                postcode,
                lat,
                lng
            };
        },

        resetPlace: function () {
            this.form.address = '';
            this.form.addressDetail = {
                province: '',
                city: '',
                suburb: '',
                postcode: '',
                lat: '',
                lng: ''
            };
        }
    }
};
</script>
